import { ValidateModelStrategy } from '@/utils/validation';
import { getIsHideHeightForOrder } from '@/utils/newOrder';

const getDocumentItemNodeImgs = ({ itemNode = null, mainNode = null }) => {
  const result = [];
  const className = typeof itemNode?.className === 'string' ? itemNode?.className : '';

  if (className === 'models-slider__warning' || className.match('__warning')) {
    return [];
  }
  if (itemNode?.childNodes?.length) {
    itemNode.childNodes.forEach(el => {
      const value = getDocumentItemNodeImgs({ itemNode: el, mainNode: itemNode });

      result.push(...value);
    });
  } else if (itemNode?.tagName === 'IMG') {
    const src = itemNode?.src || '';
    if (src.endsWith('.png') || src.endsWith('.jpg')) {
      result.push({
        src,
        zIndex: Number(mainNode.style.zIndex),
        sort: className === 'models-slider__over-material' ? 1 : 0,
      });
    }
  }

  return result;
};

export default {
  getSystem(state, getters) {
    const system = state.models[state.system];
    if (system) {
      return system;
    }

    return null;
  },

  getIsTriggerModelPopover(state) {
    return state.isTriggerModelPopover
  },

  getAccordionIsDisabled(state) {
    const { isDisabledMaterials, isDisabledSizes, isDisabledOptions } = state;

    return {
      isDisabledMaterials,
      isDisabledSizes,
      isDisabledOptions,
    };
  },

  getModel(state, getters) {
    const system = getters.getSystem;

    return system ? system.models[state.model] : null;
  },

  getSubModel(state, getters) {
    if (typeof state.subModel !== 'number') {
      return null;
    }
    const model = getters.getModel;
    const sub = model?.sub_models?.length ? model.sub_models[state.subModel] : null;

    return sub;
  },

  getModelPrice(_, getters) {
    const model = getters.getCurrentModel;
    const system = getters.getSystem

    return getIsHideHeightForOrder({ system, model });
  },

  getIsFooterBasket(state, getters) {
    const { models, materialsItem, modelSize } = state;

    return Boolean(models && materialsItem && modelSize?.width && modelSize?.height);
  },

  getIsElementBasket(state, getters) {
    return Boolean(state.queryParams?.element?.basket);
  },

  getCurrentModel(_, getters) {
    const subModel = getters.getSubModel;
    if (subModel) {
      return subModel;
    }

    const model = getters.getModel;
    if (model) {
      return model;
    }

    return null;
  },

  getIsModelRoofSystem(_, getters) {
    const model = getters.getCurrentModel;
    const validateModel = new ValidateModelStrategy(model);
    return validateModel.isRoofSystem();
  },

  getMaterialsItemImage(state) {
    const image = state.materialsItem?.image;

    if (image) {
      if (image.startsWith('/')) {
        return image;
      }

      return `/${image}`;
    }

    return '';
  },

  getModelSystemImage(_, getters) {
    const model = getters.getCurrentModel;
    return model?.image_system;
  },

  getModelFurnitureImage(_, getters) {
    const model = getters.getCurrentModel;
    return model?.image_furniture;
  },

  getPreselectedModel(state) {
    return state.preselectedModel
  },

  getPreselectedSystem(state) {
    return state.preselectedSystem
  },

  getDataImages() {
    return () => {
      const domNode = document?.getElementsByClassName('slider-panel');
      const itemNodeImgs = getDocumentItemNodeImgs({ itemNode: domNode?.[0] });

      const itemNodeImgsSort = [];
      for (let idx = 0; idx < itemNodeImgs.length; idx++) {
        const item = itemNodeImgs[idx];
        const prevItemIndex = idx - 1;

        if (item.zIndex === -1 && idx) {
          const prevItem = itemNodeImgs[prevItemIndex];

          itemNodeImgsSort.splice(prevItemIndex, 1);
          itemNodeImgsSort.push(item);
          itemNodeImgsSort.push(prevItem);
        } else {
          itemNodeImgsSort.push(item);
        }

        if (idx) {
          const prevItem = itemNodeImgsSort[prevItemIndex]
          if (prevItem.sort) {
            itemNodeImgsSort.splice(prevItemIndex, 1)
            itemNodeImgsSort.push(prevItem)
          }
        }
      }

      const images = itemNodeImgsSort.map(({ src }) => src.replace(location.origin, ''));

      return images;
    };
  },
};
